import * as _ from 'lodash';
import {
  BufferGeometry,
  Color,
  Float32BufferAttribute,
  LineBasicMaterial,
  LineSegments,
  Scene,
  Vector3,
} from 'three';
import { Dimensions } from './../../core/types';

export class Unloading {
  public dimensions: Dimensions;
  public position: Vector3;

  constructor(dimensions: Dimensions, position: Vector3) {
    this.dimensions = { width: 0, length: 0, height: 0 };
    this.position = new Vector3();
    this.times100(dimensions, position);
  }

  public times100(dimensions: Dimensions, position: Vector3) {
    this.dimensions.length = _.round(dimensions.length * 100, 2);
    this.dimensions.width = _.round(dimensions.width * 100, 2);
    this.dimensions.height = _.round(dimensions.height * 100, 2);
    this.position.x = _.round(position.x * 100, 2);
    this.position.y = _.round(position.y * 100, 2);
    this.position.z = _.round(position.z * 100, 2);
  }

  public x2(): number {
    return this.position.x + this.dimensions.width;
  }

  public y2(): number {
    return this.position.y + this.dimensions.height;
  }

  public z2(): number {
    return this.position.z + this.dimensions.length;
  }
}

export class UnloadingGround {
  private readonly COLOR: Color = new Color(0xe06666);
  private readonly MATERIAL: LineBasicMaterial = new LineBasicMaterial({
    color: this.COLOR,
    depthTest: true,
    depthWrite: false,
    polygonOffset: true,
    polygonOffsetFactor: -4,
  });

  public draw(scene: Scene, unloading: Unloading): LineSegments {
    let vertices = [];
    vertices = vertices.concat(
      this.calculateVerticesForHorizontalLines(
        unloading.dimensions.width,
        unloading.dimensions.length,
      ),
    );
    vertices = vertices.concat(
      this.calculateVerticesForVerticalLines(
        unloading.dimensions.length,
        unloading.dimensions.width,
      ),
    );

    const geometry = new BufferGeometry();
    geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
    const grid = new LineSegments(geometry, this.MATERIAL);
    grid.position.copy(unloading.position);
    grid.name = 'UnloadingGround';
    scene.add(grid);
    return grid;
  }

  private calculateVerticesForHorizontalLines(lineLength: number, axisLength: number): number[] {
    const vertices: number[] = [];
    vertices.push(0, 0, 0, lineLength, 0, 0);
    vertices.push(0, 0, axisLength, lineLength, 0, axisLength);
    return vertices;
  }

  private calculateVerticesForVerticalLines(lineLength: number, axisLength: number): number[] {
    const vertices: number[] = [];
    vertices.push(0, 0, 0, 0, 0, lineLength);
    vertices.push(axisLength, 0, 0, axisLength, 0, lineLength);
    return vertices;
  }
}
